export default __webpack_public_path__ + "static/media/pic110.3d372989.jpg";